import * as url from "../url.helper";

import { post } from "../api.helper";

export const addUser = data => post(url.ADD_USER, data);

export const getUser = data => post(url.GET_USER, data);

export const editUser = data => post(url.EDIT_USER, data);

export const deleteUser = data => post(url.DELETE_USER, data);

export const getUserByID = data => post(url.GET_USER_BY_ID, data);

export const editUserConsent = data => post(url.USER_CONSENT, data);

export const getUserByEntityType = data =>post(url.GET_USER_BY_ENTITY_TYPE, data);





